import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
    CustomizeSearchColumnsModalComponent
} from "@app2/search/search-shared/customize-search-columns-modal.component";
import { CustomizeSearchColumnsComponent } from "@app2/search/search-shared/customize-search-columns.component";
import { EventsTableComponent } from "@app2/search/search-shared/events-table.component";
import {
    SearchResultsTableDetailedValueComponent
} from "@app2/search/search-shared/search-results-table-detailed-value.component";
import { SavedQueriesEmbeddedListComponent } from "@app2/search/search-shared/saved-queries-embedded-list.component";
import {
    SavedQueriesSearchableEmbeddedListComponent
} from "@app2/search/search-shared/saved-queries-searchable-embedded-list.component";
import { EventsFieldInputComponent } from "@app2/search/search-shared/events-field-input.component";
import { SearchResultsTableComponent } from "@app2/search/search-shared/search-results-table.component";
import { WithAggregateFieldsPipe } from "@app2/shared/pipes/with-aggregate-fields.pipe";
import { SharedModule } from "@app2/shared/shared.module";
import { SavedQuerySelectorComponent } from "@app2/search/search-shared/saved-query-selector.component";
import { ThreatRatingDropdownComponent } from "@app2/threatmatch/threat-rating-dropdown.component";
import { AssetDropdownComponent } from "@app2/asset/asset-dropdown.component";
import { ReferencedObjectsComponent } from "@app2/search/referenced-objects.component";
import { QueryFinderComponent } from "@app2/search/query-finder.component";
import { RelatedObjectsListComponent } from "@app2/search/related-objects-list.component";
import { SavedQueryModalComponent } from "@app2/search/saved-query-modal.component";
import { QueryColumnSelectModalComponent } from "@app2/search/search-shared/query-column-select-modal.component";
import { SavedQuerySummaryComponent } from "@app2/search/search-shared/saved-query-summary.component";
import { MatIconModule } from "@angular/material/icon";
import { SavedQueryIconComponent } from "@app2/search/search-shared/saved-query-icon.component";
import { QueryPerformancePredictorComponent } from "@app2/search/search-shared/query-performance-predictor.component";
import { IpDropdownComponent } from "@app2/search/search-shared/ip-dropdown.component";
import { ModifiedQueryFormComponent } from "@app2/search/search-shared/modified-query-form.component";
import {
    SearchResultsTableDetailedContentComponent
} from "@app2/search/search-shared/search-results-table-detailed-content.component";
import { AddIndicatorModalComponent } from "@app2/search/search-shared/add-indicator-modal.component";
import { WatchlistsSharedModule } from "@app2/watchlists/watchlists-shared.module";

@NgModule({
    imports: [
        CommonModule,
        DragDropModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,

        SharedModule,
        MatIconModule,
        WatchlistsSharedModule,
    ],
    declarations: [
        AddIndicatorModalComponent,
        SavedQueriesEmbeddedListComponent,
        SavedQueriesSearchableEmbeddedListComponent,
        SavedQueryIconComponent,
        SavedQuerySummaryComponent,
        CustomizeSearchColumnsComponent,
        CustomizeSearchColumnsModalComponent,
        EventsTableComponent,
        SearchResultsTableDetailedValueComponent,
        SearchResultsTableDetailedContentComponent,
        IpDropdownComponent,
        SearchResultsTableComponent,
        SavedQuerySelectorComponent,
        ThreatRatingDropdownComponent,
        AssetDropdownComponent,
        ReferencedObjectsComponent,
        RelatedObjectsListComponent,
        QueryFinderComponent,
        SavedQueryModalComponent,
        QueryColumnSelectModalComponent,
        EventsFieldInputComponent,
        QueryPerformancePredictorComponent,
        ModifiedQueryFormComponent,
        WithAggregateFieldsPipe,
    ],
    exports: [
        AddIndicatorModalComponent,
        SavedQueriesSearchableEmbeddedListComponent,
        SavedQueryIconComponent,
        SavedQuerySummaryComponent,
        CustomizeSearchColumnsComponent,
        EventsTableComponent,
        SearchResultsTableDetailedValueComponent,
        SearchResultsTableDetailedContentComponent,
        IpDropdownComponent,
        SearchResultsTableComponent,
        SavedQuerySelectorComponent,
        ThreatRatingDropdownComponent,
        AssetDropdownComponent,
        ReferencedObjectsComponent,
        RelatedObjectsListComponent,
        QueryFinderComponent,
        QueryColumnSelectModalComponent,
        EventsFieldInputComponent,
        QueryPerformancePredictorComponent,
        WithAggregateFieldsPipe,
    ],
})
export class SearchSharedModule {
    constructor() {
    }
}
